const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Ugovor - Štampa</title>
          <style>
            
            .paragraph{margin: 50px 0 50px 0;font-size:11pt;line-height:1.35;text-align:justify}
            .title {text-align:center}
          *{box-sizing:border-box}
      html,body{margin:0;padding:0;font-family:Arial, sans-serif;font-size:11pt;color:#000}
      @page{size:A4 portrait;margin:20mm 20mm}

      .print-page{display:block;width:210mm;padding:20mm 20mm}
      .print-page:not(:last-child){page-break-after:always}
      @media print{.print-page{width:auto;padding:0}}
  

      /* Header/top */
      .top-row{display:flex;justify-content:center;align-items:center;}
      .broj{font-size:12pt}
      .firma{text-align:center}
      .firma .naziv{margin:0;}
      .firma .mesto{font-size:25px; margin-top: 0;}


      .titleBox {
      width: 100%;
      display:flex;
      align-items:center;
      justify-content: center;
      }
      .title{font-size:24px;text-align:center;width:fit-content;}

      .mp{    position: absolute;
          width: 10px !important;
          left: 30%;
          top: 50%;
          margin-top:6px}
      .meta{margin:0 0 4mm 0;font-size:20px;font-weight: 700;margin-top:300px;margin-bottom: 50px;}
      .meta span {
      border-bottom: 1px solid;
      }
      .paragraph{margin: 50px 0 50px 0;font-size:25px;line-height:1.35;text-align:justify}


      .sign-row{position:absolute;display:grid;grid-template-columns:1fr 1fr 1fr;}
      .sign-block{display:flex;flex-direction:column;align-items:center;justify-content:flex-end;font-size:larger;}
      .sign-title{font-weight:700;margin-bottom:20px}
      .sign-line{margin-top:28px;border-top:1px solid #000;width:100%}


      @media print{
      *{-webkit-print-color-adjust:exact;print-color-adjust:exact}
      }
                </style>
              </head>
              <body>
                <div id="print-content"></div>
              </body>
            </html>
    `;
export default function handlePrintContract(podaci) {
  
    const printWindow = window.open('', '_blank', 'width=1000,height=700');

    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    const printContainer = printWindow.document.getElementById('print-content');
    printContainer.innerHTML = podaci.htmlContent;

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 500);

};